import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { SafeSvgPipe } from '@shared/pipes';
import * as SvgResources from '../../../lib/svg.resources';

@Component({
  selector: 'app-continuation-indicator',
  templateUrl: './continuation-indicator.component.html',
  styleUrls: ['./continuation-indicator.component.scss'],
  standalone: true,
  imports: [NgClass, SafeSvgPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContinuationIndicatorComponent {
  private _isActive = false;
  get isActive(): boolean {
    return this._isActive;
  }
  @Input() set isActive(value: boolean) {
    this._isActive = value;
  }

  chevronIcon = SvgResources.sizableSvgIcon(SvgResources.svgIconTypes.chevronRight, 4);
}
